<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />
    <v-card min-height="40vh">
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-caption">
        {{ userCompany }} is pleased to announce company offered health
        wellness, dental and vision coverage. {{ userCompany }} will pay
        50% for the monthly premium. This benefit stays with you, even
        if you leave the company. All full-time employees are eligible
        to apply after 90 days of employment.
        </p>
        <p class="text-caption">
        Please indicate below if you are interested.
        </p>
        <p class="text-caption">
        Our contract is David Dodge (352) 638-2060. David is very
        knowledgebale and easy to work with.
        </p>
      </v-col>
      <v-col cols="12" md="6">
        <v-radio-group row v-model="isInterested">
          <v-radio label="Yes, I am interested!" :value="true"></v-radio>
          <v-radio label="No, I am not interested because (please explain below)" :value="false"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12" md="12">
        <v-textarea
          v-model="noReason"
            auto-grow
            outlined
        ></v-textarea>
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.employeeName"
              label="Employee Name (print)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Employee's Signature"
                @click.stop="showSignaturePad = true"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="employeeSignatureInCompanyHealth"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateSignedEmployeeInCompanyHealth"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="dateSignedEmployeeInCompanyHealth"
                @input="dateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
        <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */
import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { SignaturePad },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      dateMenu: false,
      employeeSignatureInCompanyHealth: "",
      showSignaturePad: false,
      item: {},
      step: this.currentStep,
      noReason: "",
      isInterested: null,
    };
  },

  created() {
    this.populateUserInfo();
    const savedSignature = localStorage.getItem("employeeSignatureInCompanyHealth");
    if (savedSignature) {
      this.signatureData(savedSignature);
    }
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
    ...mapGetters("users", {
      user: "user",
      userCompany: "userCompany",
    }),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),
    signatureData(data) {
      this.employeeSignatureInCompanyHealth = data;
      localStorage.setItem("employeeSignatureInCompanyHealth", data);
    },

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },
    prev() {
      this.$emit("clicked", this.step - 1);
    },
    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "client-transportation-agreement",
        });
        console.log(response);
        localStorage.setItem('dateSignedEmployeeInCompanyHealth', this.dateSignedEmployeeInCompanyHealth);
        localStorage.setItem('isInterested', this.isInterested);
        localStorage.setItem('noReason', this.noReason);
        console.log({isInterested : isInterested});
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {

      const storedIsInterested = localStorage.getItem('isInterested');
      const storedNoReason = localStorage.getItem('noReason');
      const dateSigned = localStorage.getItem('dateSignedEmployeeInCompanyHealth');


      if (storedIsInterested !== null) {
        this.isInterested = storedIsInterested === 'true' ? true : false;
      }
      if (storedNoReason !== null) {
        this.noReason = storedNoReason;
      }
      if (dateSigned !== null) {
        this.dateSignedEmployeeInCompanyHealth = dateSigned;
      }



      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.ClientTransportationAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "client-transportation-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(
        pdfFile,
        "client-transportation-agreement.pdf",
        "application/pdf"
      );
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
